import { render, staticRenderFns } from "./VerTraspaso.vue?vue&type=template&id=fa30360a&scoped=true"
import script from "./VerTraspaso.vue?vue&type=script&lang=js"
export * from "./VerTraspaso.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VerTraspaso.vue?vue&type=style&index=1&id=fa30360a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa30360a",
  null
  
)

export default component.exports